<template>
    <div class="contenedorCasosDeExito">
        <section class="contTituloCasosDeExito">
            <img src="../assets/images/bannerCasosDeExito.png" alt="" class="bannerCasosDeExito">
            <h1 class="animate__animated animate__zoomInDown">CASOS DE ÉXITO</h1>
            <p class="animate__animated animate__flipInX">CADA SOLUCIÓN QUE CREAMOS ESTÁ PENSADA PARA RESOLVER UN
                PROBLEMA REAL. ACÁ TE MOSTRAMOS ALGUNOS
                RESULTADOS
                CONCRETOS.</p>
        </section>

        <div class="contenedorBannerPatrium">
            <div class="franja"></div>
            <div class="textosBannerPatrium">
                <h2>PATRIUM CAPITAL</h2>
                <p>INDUSTRIA: FINANZAS E INVERSIONES.</p>
            </div>
            <img src="../assets/images/bannerPatrium.png" alt="">
        </div>
        <div class="textosBannerPatriumMobile">
            <h2>PATRIUM CAPITAL</h2>
            <p>INDUSTRIA: FINANZAS E INVERSIONES.</p>
        </div>
        <div class="contCuadros">
            <div class="dosCuadros">
                <div class="cuadro" data-aos="flip-left">
                    <h3>DESAFÍO</h3>
                    <span></span>
                    <p>Patrium Capital es una empresa dedicada a la <strong>gestión de inversiones.</strong> Sus
                        clientes depositan capital para que la empresa lo administre de forma estratégica en
                        instrumentos financieros como acciones, bonos, CEDEARs y dividendos. Toda su operativa se
                        realiza a través de la plataforma Balanz, desde donde ejecutan las inversiones y acceden a la
                        información financiera. Sin embargo, el seguimiento de cada cartera individual requería hasta
                        entonces un trabajo manual: cálculos uno por uno, cliente por cliente, sin automatización.</p>
                </div>
                <div class="cuadro cuadroResultado esp" data-aos="flip-left">
                    <h3>RESULTADO</h3>
                    <span></span>
                    <p>Gracias a este sistema, Patrium Capital pasó de procesos manuales y propensos al error, a una
                        <strong>gestión completamente automatizada y escalable, optimizando tiempos, precisión y
                            comunicación con sus clientes.</strong>
                    </p>
                </div>
            </div>
            <div class="unCuadro">
                <div class="cuadro" data-aos="flip-right">
                    <h3>SOLUCIÓN</h3>
                    <span></span>
                    <p>Desde Almoby desarrollamos una <strong style="color: #44849D;">solución</strong> a medida que
                        <strong> transformó por completo su operativa diaria.</strong>
                        A través de la integración con la plataforma Balanz mediante APIs, <strong> automatizamos el
                            acceso y
                            procesamiento de datos financieros en tiempo real.</strong> Creamos un dashboard interactivo
                        que muestra
                        con claridad y precisión la situación de cada cliente, incluyendo:
                    </p>
                    <div class="lista">
                        <p>
                            • Composición de cartera
                        </p>
                        <p>
                            • Renta fija y variable
                        </p>
                        <p>
                            • Fondos comunes de inversión
                        </p>
                        <p>
                            • Valor del dólar oficial y MEP</p>
                        <p>
                            • Dividendos, cupones y títulos
                        </p>
                    </div>
                    <p>
                        Además, desarrollamos un <strong> segundo módulo que permite visualizar un cluster general de
                            clientes,</strong>
                        mostrando el rendimiento individual y agrupado por tickers, liquidez en dólares y pesos, y
                        métricas clave. Esta herramienta no solo agiliza el análisis interno, sino que también permite
                        generar informes automáticos en PDF y correos personalizados con el detalle actualizado de cada
                        inversión.
                    </p>
                </div>
            </div>
            <div class="cuadro cuadroResultadoMobile esp" data-aos="flip-left">
                <h3>RESULTADO</h3>
                <span></span>
                <p>Gracias a este sistema, Patrium Capital pasó de procesos manuales y propensos al error, a una
                    <strong>gestión completamente automatizada y escalable, optimizando tiempos, precisión y
                        comunicación con sus clientes.</strong>
                </p>
            </div>

        </div>
        <img class="mobilePatrium" src="../assets/images/mobilePatrium.png" alt="" data-aos="zoom-in">

        <div class="contenedorBannerPatrium">
            <div class="franja vinoteca"></div>
            <div class="textosBannerPatrium">
                <h2>VINOTECA SABORES</h2>
                <p>GASTRONOMÍA - VENTA DE VINOS</p>
            </div>
            <img src="../assets/images/bannerVinoteca.png" alt="">
        </div>
        <div class="textosBannerPatriumMobile">
            <h2>VINOTECA SABORES</h2>
            <p>GASTRONOMÍA - VENTA DE VINOS</p>
        </div>
        <div class="contCuadros">
            <div class="dosCuadros">
                <div class="cuadro cuadroVinoteca" data-aos="flip-left">
                    <h3>DESAFÍO</h3>
                    <span></span>
                    <p>Vinoteca Sabores necesitaba una herramienta digital que representara la esencia de su propuesta:
                        una experiencia gourmet centrada en la venta de vinos y la organización de catas personalizadas.
                        El objetivo era ofrecer un <strong> canal digital accesible, visualmente atractivo y
                            funcional</strong> que
                        permitiera a sus clientes conocer los productos y servicios de manera clara, y realizar reservas
                        de forma rápida y directa.
                    </p>
                </div>
                <div class="cuadro cuadroResultado esp cuadroVinoteca cuadroVinotecaEsp" data-aos="flip-left">
                    <h3>RESULTADO</h3>
                    <span></span>
                    <p>Gracias a esta solución, Vinoteca Sabores <strong>logró digitalizar su atención al cliente de
                            manera efectiva,</strong> potenciando la conversión de visitas en reservas y facilitando la
                        gestión interna de sus eventos. La experiencia del usuario se volvió más <strong>ágil, intuitiva
                            y profesional,</strong> reforzando el posicionamiento de la marca como una vinoteca de
                        calidad con atención personalizada.
                    </p>
                </div>
            </div>
            <div class="unCuadro">
                <div class="cuadro cuadroVinoteca" data-aos="flip-right">
                    <h3>SOLUCIÓN</h3>
                    <span></span>
                    <p>Desde Almoby desarrollamos un catálogo dinámico que presenta en detalle los productos, servicios
                        y procesos de la vinoteca, con una navegación fluida y un diseño exclusivo alineado con la
                        identidad de la marca. Entre sus funcionalidades más destacadas se incluyen:
                    </p>
                    <div class="lista listaVinoteca">
                        <p>
                            • Sección "Sobre Nosotros" y contacto completo
                        </p>
                        <p>
                            • Redireccionamiento directo a WhatsApp para atención personalizada
                        </p>
                        <p>
                            • Sistema de reserva de catas integrado con Google Calendar
                        </p>
                        <p>
                            • Redirección automática a MercadoPago para abonar la experiencia</p>
                        <p>
                            •
                            Seguimiento personalizado de cada usuario por parte del equipo de Vinoteca Sabores
                        </p>
                    </div>
                </div>
            </div>
            <div class="cuadro cuadroResultadoMobile esp cuadroVinoteca cuadroVinotecaEsp" data-aos="flip-left">
                <h3>RESULTADO</h3>
                <span></span>
                <p>Gracias a esta solución, Vinoteca Sabores <strong>logró digitalizar su atención al cliente de
                        manera efectiva,</strong> potenciando la conversión de visitas en reservas y facilitando la
                    gestión interna de sus eventos. La experiencia del usuario se volvió más <strong>ágil, intuitiva
                        y profesional,</strong> reforzando el posicionamiento de la marca como una vinoteca de
                    calidad con atención personalizada.
                </p>
            </div>

        </div>
        <a href="https://vinotecasabores.com/" target="_blank" title="Ir a Vinoteca Sabores">
            <img src="../assets/images/logoVinotecaSabores.png" alt="" class="logoVinotecaSabores"></a>
        <div class="contenedorBannerPatrium">
            <div class="franja hre"></div>
            <div class="textosBannerPatrium">
                <h2>HRE CONSIGNATARIA</h2>
                <p>GANADERÍA / COMERCIALIZACIÓN DE GANADO</p>
            </div>
            <img src="../assets/images/bannerHRE.png" alt="">
        </div>
        <div class="textosBannerPatriumMobile">
            <h2>HRE CONSIGNATARIA</h2>
            <p>GANADERÍA / COMERCIALIZACIÓN DE GANADO</p>
        </div>
        <div class="contCuadros">
            <div class="dosCuadros">
                <div class="cuadro cuadroHRE" data-aos="flip-left">
                    <h3>DESAFÍO</h3>
                    <span></span>
                    <p>HRE es una consignataria de ganado dedicada a <strong>conectar compradores y vendedores,
                            obteniendo una comisión por cada operación.</strong> Su modelo de negocio tradicional
                        requería una actualización tecnológica que les permitiera mejorar su eficiencia operativa,
                        digitalizar sus procesos y brindar una experiencia más profesional a sus clientes.

                    </p>
                </div>
                <div class="cuadro cuadroResultado esp cuadroHRE cuadroHREEsp" data-aos="flip-left">
                    <h3>RESULTADO</h3>
                    <span></span>
                    <p>La solución desarrollada permitió a HRE <strong>profesionalizar su operación, ahorrar tiempo en
                            tareas administrativas y mejorar la comunicación con sus clientes.</strong> Hoy cuentan con
                        una <strong>plataforma digital robusta, ágil</strong> y pensada para el día a día del negocio
                        ganadero, consolidando su posición como una consignataria moderna y eficiente.
                    </p>
                </div>
            </div>
            <div class="unCuadro">
                <div class="cuadro cuadroHRE" data-aos="flip-right">
                    <h3>SOLUCIÓN</h3>
                    <span></span>
                    <p>Desde Almoby llevamos adelante una transformación digital integral para HRE, desarrollando una
                        <strong>página web integrada con un sistema de gestión propio.</strong> Todo lo que se carga en
                        el sistema impacta automáticamente en la web, permitiendo una actualización constante y en
                        tiempo real. Entre las principales funcionalidades desarrolladas se destacan:
                    </p>
                    <div class="lista listaHRE">
                        <p>
                            • Gestión completa de remates, con carga de lotes clasificados por tipo: vientre, invernada,
                            faena, equinos, bubalinos y ovinos.
                        </p>
                        <p>
                            • Subida de videos para cada lote, con formato específico para su visualización en remates
                            online
                        </p>
                        <p>
                            • Administración de distintos tipos de usuarios: administrador, comisionista y editor de
                            video.
                        </p>
                        <p>
                            • Sección "Cargar Campo" para publicar propiedades rurales en venta con toda su información
                            detallada.</p>
                        <p>
                            •
                            Módulo “Promedios”: permite registrar en tiempo real los datos de cada lote rematado (precio
                            por kilo, comprador, valor final), generando automáticamente un informe completo del remate
                            que puede ser compartido con los clientes
                        </p>
                    </div>
                </div>
            </div>
            <div class="cuadro cuadroResultadoMobile esp cuadroHRE cuadroHREEsp" data-aos="flip-left">
                <h3>RESULTADO</h3>
                <span></span>
                <p>La solución desarrollada permitió a HRE <strong>profesionalizar su operación, ahorrar tiempo en
                        tareas administrativas y mejorar la comunicación con sus clientes.</strong> Hoy cuentan con
                    una <strong>plataforma digital robusta, ágil</strong> y pensada para el día a día del negocio
                    ganadero, consolidando su posición como una consignataria moderna y eficiente.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'casosDeExito'
}
</script>

<style scoped>
.contenedorCasosDeExito {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px 0;
    width: 100%;
}

.contTituloCasosDeExito {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
}

.bannerCasosDeExito {
    position: absolute;
    width: 100%;
    z-index: 0;
    height: 260%;
    object-fit: cover;
    -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: cover;
    mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
    mask-repeat: no-repeat;
    mask-size: cover;
}


.contenedorCasosDeExito h1 {
    position: relative;
    z-index: 0;
    font-weight: 800;
    font-size: 5vw;
    line-height: 120.16%;
}

.contenedorCasosDeExito p {
    position: relative;
    z-index: 0;
    font-weight: 500;
    font-size: 1.2vw;
    line-height: 120%;
    width: 60%;
}

.contenedorBannerPatrium {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}

.textosBannerPatrium {
    z-index: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
}

.textosBannerPatriumMobile h2,
.textosBannerPatriumMobile p {
    display: none;
}

.textosBannerPatrium h2 {
    font-weight: 800;
    font-size: 3vw;
    line-height: 104%;

}

.textosBannerPatrium p {
    font-weight: 500;
    font-size: 1.2vw;
    line-height: 26px;
    width: 100%;
}

.contenedorBannerPatrium img {
    z-index: 0;
    width: 50%;
    height: 50%;
    object-fit: contain;
}

.franja {
    background: linear-gradient(90deg, #3F7A92 0%, #13252C 88.46%, #020507 100%);
    height: 13vw;
    width: 100%;
    z-index: 0;
    position: absolute;
}

.vinoteca {
    background: linear-gradient(90deg, #7B6A4E 0%, rgba(49, 40, 25, 0.28) 100%);
}

.hre {
    background: linear-gradient(90deg, #004322 0%, rgba(49, 40, 25, 0.28) 100%);
}

.contCuadros {
    display: flex;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    padding: 100px;
    gap: 20px;
}

.unCuadro {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.dosCuadros {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 50%;
}

.unCuadro .cuadro {
    flex: 1;
}

.cuadro {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    background: rgba(41, 78, 94, 0.24);
    padding: 50px;
    flex: 1;
}

.cuadroResultadoMobile {
    display: none;
}

.cuadroVinoteca {
    background: #120F0A
}

.cuadroHRE {
    background: #030503
}

.esp {
    background: linear-gradient(90deg, #3F7A92 0%, #13252C 100%);
}

.cuadroVinotecaEsp {
    background: linear-gradient(90deg, #7B6A4E 0%, rgba(49, 40, 25, 0.28) 100%);
}

.cuadroHREEsp {
    background: linear-gradient(90deg, #023F20 0%, rgba(49, 40, 25, 0.28) 100%);
}


.cuadro h3 {
    font-weight: 500;
    font-size: 38px;
    line-height: 120.16%;

}

.cuadro p {
    text-align: left;
    width: 100%;
    font-family: 'WorkSans';
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    letter-spacing: 0.3px;
}

.cuadro span {
    background: linear-gradient(90deg, #29505F 0%, #55A6C5 100%);
    border: 0.692308px solid #A73314;
    height: 8px;
    width: 130px;
    margin-top: 10px;
    margin-bottom: 15px;
}

.cuadroVinoteca span {
    background: linear-gradient(90deg, #927A55 0%, #3C3222 100%);
}

.cuadroHRE span {
    background: linear-gradient(90deg, #07381D 0%, #020402 100%);
}

.esp span {
    background: #FFFFFF;
    border: 0.692308px solid #A73314;
    height: 8px;
    width: 130px;
    margin-top: 10px;
    margin-bottom: 15px;
}

.lista {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.lista p {
    font-weight: 600;
    color: #44849D;
}

.listaVinoteca p {
    color: #746349;
}

.listaHRE p {
    color: #ffffff;
}

.mobilePatrium {
    width: 85%;
    margin-bottom: 200px;
}

.logoVinotecaSabores {
    width: 30%;
}

@media screen and (max-width: 1000px) {
    .contCuadros {
        padding: 20px;
        margin-bottom: 100px;
    }

    .cuadro h3 {
        font-size: 25px;
    }

    .cuadro p {
        font-size: 14px;
    }

    .mobilePatrium {
        width: 100%;
        margin-bottom: 100px;
    }

    .contenedorBannerPatrium {
        margin-bottom: 50px;
    }
}

@media screen and (max-width: 768px) {
    .cuadro {
        padding: 20px;
    }

    .contCuadros {
        flex-direction: column;
        align-items: center;
    }

    .dosCuadros {
        width: 100%;
    }

    .cuadroResultadoMobile {
        display: flex;
    }

    .cuadroResultado {
        display: none;
    }

    .textosBannerPatrium h2,
    .textosBannerPatrium p {
        display: none;
    }

    .textosBannerPatriumMobile h2,
    .textosBannerPatriumMobile p {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .textosBannerPatriumMobile h2 {
        font-size: 6vw;
    }

    .textosBannerPatriumMobile p {
        font-size: 2vw;
        margin-bottom: 40px;
    }

    .contenedorBannerPatrium {
        margin-top: 50px;
        margin-bottom: 50px;
    }

    .contenedorBannerPatrium img {
        width: 100%;
    }

    .franja {
        height: 25vw;
    }

    .logoVinotecaSabores {
        width: 60%;
        margin-bottom: 50px;
    }

    .contenedorCasosDeExito h1 {
        font-size: 8vw;
    }

    .contenedorCasosDeExito p {
        font-size: 20px;
        width: 90%;
    }

}
</style>